import { SupportedDialCodeCountry } from '../types/phoneDialCode'

export const dialCodesByCountry: Record<SupportedDialCodeCountry, string> = {
  DE: '+49',
  DK: '+45',
  FR: '+33',
  NL: '+31',
}

export const languageToCountry: Record<string, SupportedDialCodeCountry> = {
  da: 'DK',
  de: 'DE',
  fr: 'FR',
  nl: 'NL',
}

export const DEFAULT_DIAL_CODE = dialCodesByCountry.FR
